<template>
  <resource-base
    :ref="resourceBaseRef"
    :loading-display="false"
    :is-management-mode="isManagementMode"
    :display-activity="myAppSettings_isDisplayActivity"
    :display-settings="myAppSettings_isDisplaySettings"
    :resource="resource"
    :settings="settings"
    @appLog="appLog"
    @settings-gen-changed="handleSettingsGenChange"
    @update-settings="handleUpdateSettings"
  >
    <template v-slot:display>
      <b-container>
        <display
          :resource="resource"
          :settings="settings"
          :user-data="userData"
          @appLog="appLog"
          @user-clicked-about="handleUserClickedAbout"
          @update-user-data="handleUpdateUserData"
        />
      </b-container>
    </template>
    <template v-slot:activity>
      <activity :resource="resource" />
    </template>
    <template v-slot:settings>
      <settings
        :resource="resource"
        :settings="settings"
        @resource-updated="handleRefreshResource"
        @update-user-data="handleUpdateUserData"
      />
    </template>
  </resource-base>
</template>

<script>
import ResourceBase from "../resourceBase";
import Display from "./sections/display";
import Activity from "./sections/activity";
import Settings from "./sections/settings";
import ResourceBlockIndex from "@/mixins/resourceBlocks/Index";
import themesJSON from "./assets/json/themes.json";
export default {
  name: "Resource_Bend",
  mixins: [ResourceBlockIndex],
  components: {
    ResourceBase,
    Display,
    Activity,
    Settings
  },
  created() {
    //Set Up ENV here
    if (this.settings_bgTheme) {
      //Place om Config https://d3rriana.com/
      let devURLPath = "http://localhost:8080/assets/apps/calllog/";
      let prodURLPath =
        "https://d3rriana.com/assets/apps/calllog/";
      this.appSetUp.bgImgURL = `${devURLPath}${this.bgTheme.bgImgPath}`;
      this.appSetUp.useStyleClass = "none";
    }
    this.handleSetUp();
  },
  mounted() {},
  computed: {
    /* SETTTINGS */
    settings_bgTheme() {
      return this.settings && this.settings.user
        ? this.settings.user.bgTheme
        : null;
    },
    /* SETTINGS- DONE */
    bgTheme() {
      //has cards and other values
      if (Array.isArray(themesJSON) && this.settings_bgTheme) {
        let theThemeData = themesJSON.filter(aTheme => {
          return aTheme.value === this.settings_bgTheme;
        });
        return theThemeData[0];
      }
      return themesJSON[0]; //default theme
    }
  },
  methods: {
    handleRefreshResource() {
      this.$emit("refresh-publishing");
    },
    showResource() {
      this.show = true;
    },
    appLog(data) {
      //Use Mixins
      this.$emit("appLog", data);
    }
    /*REMOVE
    handleSettingsUserChange(settings) { //can be a mixin
      this.$emit("settings-user-changed", settings);
    }*/
  },
  data() {
    return {
      appSetUp: {
        useBgImgClass: false,
        bgImgURL:
          "https://images.unsplash.com/photo-1502987846294-e7ec70f4b393?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1373&q=80"
      },
      show: false,
      title: this.resource.name,
      imgURL: this.resource.imgURL,
      faIcon: this.resource.icon ? this.resource.icon : "fa-folder"
    };
  }
};
</script>

<style lang="scss">
img {
  cursor: pointer;
}
</style>
